﻿import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static get targets() {
        return ["gifPause", "status"];
    }

    togglePause(event) {
        event.preventDefault();

        const img = this.gifPauseTarget;
        const status = this.statusTarget;

        const currentSrc = img.getAttribute("src");
        const stillSrc = img.getAttribute("data-still");
        const gifSrc = img.getAttribute("data-gif");

        if (currentSrc === gifSrc) {
            img.setAttribute("src", stillSrc);
            status.textContent = "play_circle";
        } else {
            img.setAttribute("src", gifSrc);
            status.textContent = "pause_circle";
        }
    }
}
